import { render, staticRenderFns } from "./optLogger.vue?vue&type=template&id=d1cb3636&"
import script from "./optLogger.vue?vue&type=script&lang=js&"
export * from "./optLogger.vue?vue&type=script&lang=js&"
import style0 from "./optLogger.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports